import * as React from "react";
import {cx}       from "emotion";

import "./blank-canvas-layout.scss";

import {ComponentLink,
        Link,
        makeChain}      from "@Common/react/cst2";
import {Types}          from "@Common/types";

import {LoadingSpinner} from "../components/loading-spinner";
import {SelectionTile}  from "../components/selection-tile";


export const BlankCanvasLayout = ({
    layouts
}:{
    layouts  : Types.Common.React.Load2.Load2Next<any[]>,
}) => (

    makeChain<JSX.Element>()

    // create method to create subtext
    .then("getSubText", ({}, next:Link<JSX.Element, (layout:any) => JSX.Element>) => next(layout => {

        return <>
            {layout.product.name}<br/>
            Finished Size: {layout.product.finishedWidth}” × {layout.product.finishedHeight}”<br/>
            Flat Size: {layout.product.flatWidth}” × {layout.product.flatHeight}”
        </>;

    }))

    // render view
    .then(({getSubText}) => (
        <div className="blank-canvas-layout-d6d">
            {(layouts.loading || layouts.value?.length > 0) && <>
                {layouts.loading ? (
                    <LoadingSpinner text="Loading Layouts"/>
                ) : layouts?.value.map(layout => (
                    <SelectionTile
                        key={layout.id}
                        text={layout.name.split(" - ").slice(0, 2).join(" - ")}
                        subText={getSubText(layout)}
                        image={layout.images[Object.keys(layout.images)?.[0]]?.url}
                        onClick={() => window.location.hash = `#new-template-upload-modal-${layout.id}-new`}
                    />
                ))}
            </>}
        </div>
    ))

    .run()

);
